/* this file is transformed by vux-loader */
/* eslint-disable */
import _regenerator from "E:/pm-ningde/ppos-web-propertyManage/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/pm-ningde/ppos-web-propertyManage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Tab from "vux/src/components/tab/tab.vue";
import TabItem from "vux/src/components/tab/tab-item.vue";
import LoadMore from "@/components/LoadMore";
import Xhead from "@/components/XHeader";
import bus from "@/utils/bus";
import NoData from "@/components/NoData";
import { handleActionList } from "@/api/problemHandling";
export default {
  components: {
    Tab: Tab,
    TabItem: TabItem,
    "v-scllo": LoadMore,
    NoData: NoData,
    Xhead: Xhead
  },
  data: function data() {
    return {
      title: "问题处理",
      num: [],
      list: [],
      items: [{
        name: "待我处理的",
        id: "0"
      }, {
        name: "我已处理的",
        id: "1"
      }],
      // ****下拉加载相关
      loadingText: "上拉加载 ...",
      status: 0,
      page: 1,
      pagesize: 10,
      total_page: -1
    };
  },
  created: function created() {
    var _this = this;
    this.$nextTick(function () {
      _this.status = _this.$route.query.status || 0;
      _this.getHandleActionList();
    });
  },
  methods: {
    handler: function handler(status) {
      this.page = 1;
      this.list = [];
      this.total_page = -1;
      this.status = status;
      bus.$emit("infiniteLoading", false);
      this.getHandleActionList();
    },
    // 获取列表
    getHandleActionList: function getHandleActionList(done) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var param, _yield$handleActionLi, list, total, showFooter;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              param = {
                page: _this2.page,
                size: _this2.pagesize,
                status: _this2.status
              };
              _context.n = 1;
              return handleActionList(param);
            case 1:
              _yield$handleActionLi = _context.v;
              list = _yield$handleActionLi.list;
              total = _yield$handleActionLi.total;
              _this2.num[_this2.status] = total;
              _this2.total_page = total;
              if (!(Math.ceil(_this2.total_page / _this2.pagesize) < _this2.page)) {
                _context.n = 2;
                break;
              }
              _this2.loadingText = "已经没有更多了";
              return _context.a(2);
            case 2:
              _this2.list = _this2.list.concat(list);
              _this2.page++;
              _this2.loadingText = "上拉加载 ...";
              showFooter = {
                total_page: _this2.total_page,
                page_size: _this2.pagesize
              };
              bus.$emit("showFooter", showFooter);
            case 3:
              if (done) {
                done();
              }
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    // 下拉刷新 必须存在
    onRefresh: function onRefresh() {},
    // 上拉加载
    onInfinite: function onInfinite(done) {
      this.getHandleActionList(done);
    },
    // 跳转详情
    detailClick: function detailClick(related_no) {
      var routerParam = {
        name: "ProblemHandlingDetail",
        query: {
          related_no: related_no,
          status: this.status
        }
      };
      this.$router.push(routerParam);
    }
  }
};